import { isBrowser } from '../../env'
import { BRIDGE_ERRORS } from '../../constant/bridge-erros.enum'
let _pipe = null
if (isBrowser()) {
  _pipe = {}
} else {
  const net = require('net')
  _pipe = class PIPE {
    constructor(pipePath) {
      this.pipePath = pipePath
      this._connections = []
      this._events = {}
      this._invokeMap = {}
      this._server = net.createServer((connection) => {
        this._connections = [...this._connections, connection]
        const raw_strbuf = []
        connection.on('data', (message) => {
          for (const char of message) {
            if (char === 0x00 && raw_strbuf.length > 0) {
              const str = Buffer.from(raw_strbuf.splice(0, raw_strbuf.length), 'utf8').toString()
              try {
                const json = JSON.parse(str)
                const targetModuleName = json['_to']
                if (targetModuleName && targetModuleName === 'inface') {
                  /** heartbeat */
                } else if (targetModuleName && this._events[targetModuleName]) {
                  const invokeId = json._invoke
                  if (invokeId && invokeId > 0) {
                    if (this._invokeMap[targetModuleName] && this._invokeMap[targetModuleName][invokeId]) {
                      const returnValue = json._return
                      const timerValue = this._invokeMap[targetModuleName][invokeId]['timer']
                      if (timerValue !== 0 && timerValue !== BRIDGE_ERRORS.CHANNEL_TIMEOUT) {
                        this._invokeMap[targetModuleName][invokeId]['resolve'](returnValue)
                        clearTimeout(timerValue)
                      }
                      delete this._invokeMap[targetModuleName][invokeId]
                    } else {
                      console.error(`${targetModuleName}::${invokeId} resolve not exitsts`)
                    }
                  } else {
                    const cbList = this._events[targetModuleName]
                    cbList.forEach(cb => cb(targetModuleName, json, connection))
                  }
                } else {
                  const cannotFoundModulePayload = {
                    ...json,
                    _from: 'inface-sdk',
                    _data: {},
                    _error: {
                      code: 110003,  // TODO: common 의 FAILED_ACTION 코드와 동일하게 유지필요
                      name: 'FAILED_ACTION',
                      message: `undefined ${targetModuleName} module`
                    }
                  }
                  this.broadcast('game', cannotFoundModulePayload)
                  continue;
                }

                if (this._events['*']) {
                  const cbList = this._events['*']
                  cbList.forEach(cb => cb(targetModuleName, json, connection))
                }

                this.broadcast(targetModuleName, json, [connection])
              } catch (e) {
                console.error('parser error ', e, str)
                raw_strbuf.splice(0, raw_strbuf.length)
              }
            } else {
              if (char !== 0x00) {
                raw_strbuf.push(char)
              }
            }
          }
        })
        connection.on('end', () => {
          this._connections = this._connections.filter(existsConnection => existsConnection !== connection)
        })
      })

      this._server.on('connection', (connection) => {
        connection.unref()
      })

      this._server.on('error', (error) => {
        console.error('error on server', error)
      })

      this._server.on('close', () => {
        console.error('close on server',)
      })
    }

    start() {
      this._server.listen(this.pipePath)
      return this
    }

    stop() {
      this._server.getConnections().forEach(con => {
        con.destroy()
      })
      this._server.close()
    }

    broadcast(event, payload, ignoreConnections = []) {
      if (!event || !payload) {
        throw Error('event or payload is null')
      }

      if (typeof payload !== 'object') {
        throw Error('only support by object type when broadcast')
      }

      this._connections
        .filter(connection => !ignoreConnections.includes(connection))
        .forEach(connection => {
          try {
            this.send(connection, event, payload)
          } catch (e) {
            console.error(e)
          }
        })
    }

    invokeAction(from, payload, ignoreConnections = []) {
      return new Promise((resolve, reject) => {
        if (typeof payload['_action'] === 'undefined') {
          return resolve(BRIDGE_ERRORS.PARAM_IS_NULL)
        }

        if (typeof payload['_payload'] === 'undefined') {
          return resolve(BRIDGE_ERRORS.PARAM_IS_NULL)
        }

        if (typeof payload['_payload'] !== 'object') {
          return resolve(BRIDGE_ERRORS.PARAM_IS_INVALID_JSON)
        }

        if (!this._invokeMap[from]) {
          this._invokeMap[from] = {}
        }

        const invokeId = payload._invoke
        if (!this._invokeMap[from][invokeId]) {
          this._invokeMap[from][invokeId] = {
            resolve,
            'timer': 0
          }
        }
        this._invokeMap[from][invokeId]['timer'] = setTimeout(() => {
          clearTimeout(this._invokeMap[from][invokeId]['timer'])
          this._invokeMap[from][invokeId]['timer'] = BRIDGE_ERRORS.CHANNEL_TIMEOUT
          resolve(BRIDGE_ERRORS.CHANNEL_TIMEOUT)
        }, 60 * 1000)

        this._connections
          .filter(connection => !ignoreConnections.includes(connection))
          .forEach(connection => {
            try {
              this.send(connection, 'end-user', payload)
            } catch (e) {
              console.error(e)
            }
          })
      })
    }

    send(connection, event, payload) {
      if (!connection) {
        throw Error('connection is null')
      }

      if (!event || !payload) {
        throw Error('event or payload is null')
      }

      if (typeof payload !== 'object') {
        throw Error('only support by object type when broadcast')
      }
      const request = {
        ...payload,
        _to: event
      }
      const request_raw = Buffer.from(JSON.stringify(request))
      const end_raw = Buffer.from([0x00])
      const packet = Buffer.concat([request_raw, end_raw])

      return connection.write(packet)
    }

    addEventListener(event, listener) {
      if (!event || !listener) {
        throw Error('cannot found addEventListener arguments event or listener')
      }

      if (!this._events[event]) {
        this._events[event] = []
      }

      this._events[event].push(listener)
    }

    removeEventListener(event, listener) {
      if (this._events[event]) {
        this._events = this._events.filter(existsListener => listener !== existsListener)
      }
    }

    createConnection(info) {
      const { onEvent } = info || { onEvent: (data) => { console.log(`[ON EVENT] ${data}`) } }
      console.log('begin connect')
      const connection = net.connect(this.pipePath, function () {
        console.log('start')
        this.on('data', (message) => {
          const raw_strbuf = []
          for (const char of message) {
            if (char === 0x00 && raw_strbuf.length > 0) {
              const str = Buffer.from(raw_strbuf.splice(0, raw_strbuf.length), 'utf8').toString()
              if (onEvent) {
                try {
                  const jsonPayload = JSON.parse(str)
                  onEvent(jsonPayload)
                } catch (e) {
                  console.error('cannot parse response to json ', e)
                  onEvent(str)
                }
              } else {
                console.error('unknown data response.')
                raw_strbuf.splice(0, raw_strbuf.length)
              }
            } else {
              if (char !== 0x00) {
                raw_strbuf.push(char)
              }
            }
          }

        })
      })
      return {
        send: (request) => {
          const request_raw = Buffer.from(JSON.stringify(request))
          const end_raw = Buffer.from([0x00])
          const packet = Buffer.concat([request_raw, end_raw])
          return connection.write(packet)
        }
      }
    }
  }
}

export const PIPE = _pipe